export default {"src":"/_next/static/media/deposit.b72375f6.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};